import React from "react";
import { FiFilter, FiRefreshCw, FiTrash2, FiBarChart2 } from "react-icons/fi";

const CARD = {
  background: "#fff",
  borderRadius: 16,
  border: "1px solid #e9ecef",
  boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
  overflow: "hidden",
};

const FilterPanel = ({ children, onApply, onClear, count }) => {
  return (
    <aside style={{ display: "flex", flexDirection: "column", gap: 14 }}>

      {/* Main filter card */}
      <div style={CARD}>

        {/* Header */}
        <div style={{ background: "#eef4fb", padding: "14px 16px", display: "flex", alignItems: "center", justifyContent: "space-between", borderBottom: "1px solid #dde6f5" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div style={{ width: 34, height: 34, borderRadius: 10, background: "#dde6f5", display: "flex", alignItems: "center", justifyContent: "center", color: "#1b5a90" }}>
              <FiFilter size={16} />
            </div>
            <span style={{ fontSize: 16, fontWeight: 700, color: "#1a1a2e" }}>Filters</span>
          </div>
          {onClear && (
            <button
              type="button"
              onClick={onClear}
              style={{ width: 32, height: 32, borderRadius: "50%", background: "#dde6f5", border: "none", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", color: "#1b5a90" }}
              title="Reset filters"
            >
              <FiRefreshCw size={14} />
            </button>
          )}
        </div>

        {/* Fields */}
        <div style={{ padding: "16px" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: 0 }}>
            {children}
          </div>

          {onApply && (
            <button
              type="button"
              onClick={onApply}
              style={{ marginTop: 4, width: "100%", display: "flex", alignItems: "center", justifyContent: "center", gap: 8, padding: "11px 14px", borderRadius: 12, background: "#1b5a90", border: "none", color: "#fff", fontWeight: 600, fontSize: 13, cursor: "pointer" }}
            >
              Apply Filters
            </button>
          )}

          {onClear && (
            <button
              type="button"
              onClick={onClear}
              style={{ marginTop: 8, width: "100%", display: "flex", alignItems: "center", justifyContent: "center", gap: 8, padding: "11px 14px", borderRadius: 12, background: "#fff5f5", border: "1.5px solid #fca5a5", color: "#dc2626", fontWeight: 600, fontSize: 13, cursor: "pointer" }}
            >
              <FiTrash2 size={14} />
              Clear Filters
            </button>
          )}
        </div>
      </div>

      {/* Count card */}
      {count !== undefined && count !== null && (
        <div style={{ ...CARD, overflow: "visible", padding: "16px" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 8 }}>
            <span style={{ fontSize: 10, fontWeight: 700, color: "#8a94a6", letterSpacing: 1.2, textTransform: "uppercase" }}>Count</span>
            <div style={{ width: 34, height: 34, borderRadius: 10, background: "#eef4fb", display: "flex", alignItems: "center", justifyContent: "center", color: "#1b5a90" }}>
              <FiBarChart2 size={16} />
            </div>
          </div>
          <div style={{ fontSize: 30, fontWeight: 800, color: "#1a1a2e" }}>{count}</div>
        </div>
      )}
    </aside>
  );
};

const Field = ({ label, children }) => (
  <div className="filter-panel__field" style={{ marginBottom: 14 }}>
    {label && (
      <div style={{ fontSize: 10, fontWeight: 700, color: "#8a94a6", letterSpacing: 1.2, textTransform: "uppercase", marginBottom: 6 }}>
        {label}
      </div>
    )}
    {children}
  </div>
);

FilterPanel.Field = Field;

export default FilterPanel;
